import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const navLinks = [
  { label: "Inicio", path: "/" },
  { label: "Persianas", path: "/servicios/persianas" },
  { label: "Mosquiteras", path: "/servicios/mosquiteras" },
  { label: "Motorización", path: "/servicios/motorizacion" },
  { label: "Guías", path: "/guias" },
  { label: "Barrios", path: "/#barrios" },
  { label: "Sobre Nosotros", path: "/sobre-nosotros" },
  { label: "Contacto", path: "/contacto" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* Top info bar */}
      <div className="fixed top-0 left-0 right-0 z-[55] w-full bg-secondary-900/95 backdrop-blur-sm border-b border-secondary-800/60">
        <div className="px-4 md:px-6">
          <div className="flex items-center justify-center gap-3 md:gap-6 py-2.5 overflow-x-auto whitespace-nowrap text-xs md:text-sm text-background-200">
            <span className="flex items-center gap-1 text-accent-400 font-semibold">⭐ 4.9/5 · 287 reseñas</span>
            <span className="text-foreground-500 select-none">·</span>
            <span className="text-background-300">+10 años en Málaga</span>
            <span className="text-foreground-500 select-none">·</span>
            <span className="text-background-300">Presupuesto gratis</span>
            <span className="text-foreground-500 select-none">·</span>
            <span className="hidden sm:inline text-background-300">2 años de garantía</span>
            <span className="hidden sm:inline text-foreground-500 select-none">·</span>
            <span className="text-background-300">16 barrios de Málaga</span>
            <span className="text-foreground-500 select-none">·</span>
            <a href="tel:+34951120770" className="inline-flex items-center gap-1 text-accent-400 hover:text-accent-300 font-semibold transition-colors cursor-pointer">
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-phone-fill text-sm"></i></span>
              951 12 07 70
            </a>
          </div>
        </div>
      </div>

      {/* Main header */}
      <header
        className={`fixed top-[40px] left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-background-50/95 backdrop-blur-sm shadow-sm" : "bg-background-50/95 backdrop-blur-sm"
        }`}
      >
        <div className="w-full px-4 md:px-6">
          <div className="flex items-center justify-between h-16 md:h-[72px]">
            {/* Logo */}
            <div className="flex items-center gap-2 md:gap-3">
              <Link to="/" className="flex items-center gap-2 group">
                <span className="text-xl md:text-2xl font-bold text-primary-600 font-heading tracking-tight">
                  Persianas
                </span>
                <span className="hidden sm:inline text-xs font-semibold text-accent-600 bg-accent-100/60 px-2 py-0.5 rounded-full">
                  Málaga
                </span>
              </Link>
            </div>

            {/* Desktop nav */}
            <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* Actions */}
            <div className="flex items-center gap-2 md:gap-3">
              <a
                href="tel:+34951120770"
                className="hidden md:inline-flex items-center gap-1.5 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-background-50 text-sm font-semibold px-4 py-2.5 rounded-full transition-all whitespace-nowrap cursor-pointer shadow-md shadow-primary-500/20"
              >
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-base"></i></span>
                Llámanos: 951 12 07 70
              </a>
              <a
                href="tel:+34951120770"
                className="md:hidden inline-flex items-center justify-center w-10 h-10 bg-gradient-to-r from-primary-500 to-primary-600 text-background-50 rounded-full transition-all cursor-pointer shadow-md shadow-primary-500/20"
              >
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-lg"></i></span>
              </a>
              {/* Mobile hamburger */}
              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="lg:hidden inline-flex items-center justify-center w-10 h-10 text-foreground-700 hover:text-primary-500 transition-colors cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`ri-${mobileOpen ? "close-line" : "menu-3-line"} text-xl`}></i>
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="lg:hidden bg-background-50 border-t border-background-200/60 px-4 py-4">
            <nav className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setMobileOpen(false)}
                  className="text-sm text-foreground-700 hover:text-primary-500 transition-colors py-2 border-b border-background-200/40"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </header>

      {/* Spacer for fixed header */}
      <div className="h-[104px] lg:h-[112px]" aria-hidden="true" />
    </>
  );
}